import { createRef, useEffect, useState } from 'react'
import { createStyles, makeStyles, Theme } from '@material-ui/core'
import { CadExCanvas } from './CaxExCanvas'
import { CadExProvider } from './context/CadExProvider'
import { CADExViewerProps } from './types'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      height: '100%',
      width: '100%',
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      // borderRadius: '12px',
      // border: `solid 1px ${lighten(theme.palette.primary.light, .8)}`,
      overflow: 'hidden',
    },
    cadex: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      zIndex: 2,
      '& :nth-child(2)': {
        opacity: '.0',
        zIndex: -1,
      },
    },
  })
)

export const CadExViewer = (props: CADExViewerProps) => {
  const [showCanvas, setShowCanvas] = useState(false)
  const ref = createRef<HTMLDivElement>()
  const cn = useStyles()

  useEffect(() => {
    const id = setTimeout(() => setShowCanvas(true), 2000)
    return () => clearTimeout(id)
  }, [])

  return (
    <CadExProvider reference={ref} {...props}>
      <div className={cn.root}>
        <div className={cn.cadex} ref={ref}></div>
        {showCanvas && <CadExCanvas />}
      </div>
    </CadExProvider>
  )
}

export default CadExViewer
